import React from 'react';
import FilmStrip from './FilmStrip';
import Generator from './Generator';
import { getTexts } from '../config/texts';
import './HeroSection.css';

const HeroSection = ({ language, setCurrentPage }) => {
  const texts = getTexts('hero', language);

  return (
    <div className="hero-viewport">
      <div className={`hero-text ${language === 'en' ? 'hero-text-en' : 'hero-text-zh'}`}>
        <h1>{texts.title}</h1>
        <p>{texts.subtitle}</p>
      </div>

      <FilmStrip />
      <Generator language={language} setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default HeroSection;